module.exports = __webpack_public_path__ + "static/img/map-bg.14e3c690.jpg";